import styled from '@emotion/styled'
import React from 'react'

import { AccessInstruction } from '@/types/Homes'

import { getAccessInstructionIcon, getUserTypeIcon } from './AccessInstruction.data'

type Props = {
  accessInstruction: AccessInstruction
  handleEditInstruction: (accessInstruction: AccessInstruction) => void
}

export const AccessInstructionMobileCard = ({ accessInstruction, handleEditInstruction }: Props) => {
  const { accessibleType, instruction, name, userType } = accessInstruction

  return (
    <BoxStyled role="presentation">
      <div className="flex">
        <div className="flex-col">{getAccessInstructionIcon(accessibleType)}</div>
        <div className="flex-col">{getUserTypeIcon(userType)}</div>
        <div className="flex-col" onClick={() => handleEditInstruction(accessInstruction)} role="presentation">
          <p className="text-sm">{name}</p>
          <p className="text-xs text-tertiary">{instruction}</p>
        </div>
      </div>
    </BoxStyled>
  )
}

const BoxStyled = styled.div`
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 1rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);

  .bordered-column {
    border-right-width: 1px;
    padding-left: 0.5rem;
    border-color: #e7e6e4;
  }
`
